import { Injectable } from '@angular/core';
import { createURLParser } from '@mdd/api';
import { environment } from '../../environments/environment';
import { Environment, EnvironmentInterface } from '../presentation/delegates';

@Injectable()
export class EnvironmentService implements EnvironmentInterface {
    get production(): boolean {
        return this.current === 'prod';
    }

    get test(): boolean {
        return this.current === 'test';
    }

    get test2(): boolean {
        return this.current === 'test2';
    }

    get localhost(): boolean {
        return this.current === 'local';
    }

    current: Environment;

    constructor() {
        let { hostname } = createURLParser(window.location.href);
        if (hostname.startsWith('localhost')) {
            // @ts-ignore: Object is possibly 'undefined' error
            hostname = (environment.apiBase && environment.apiBase.host) || hostname;
        }

        if (hostname.startsWith('localhost')) {
            this.current = 'local';
        } else if (hostname.includes('test2')) {
            this.current = 'test2';
        } else if (hostname.includes('test')) {
            this.current = 'test';
        } else {
            this.current = 'prod';
        }

        (window as any).dataLayer.push({ environment: this.current });
    }

    getPrefix(): string {
        if (this.test) {
            return 'test-';
        } else if (this.test2) {
            return 'test2-';
        } else if (this.localhost) {
            return 'local-';
        } else {
            return '';
        }
    }
}
